class ElVideoSlider {
  constructor(section = document) {
    this.section = section;
    this.cards = section.querySelectorAll(".el-freshflow-media-slider__card");
    this.init();
  }

  init() {
    this.cards.forEach((card) => {
      if (card.dataset.elVideoSliderInit === "true") return;

      const video = card.querySelector(".el-freshflow-media-slider__video");
      const playButton = card.querySelector(".el-freshflow-media-slider__play");
      if (!video) return;
      card.dataset.elVideoSliderInit = "true";

      if (!playButton) return;

      // Press-to-play on all templates (including FreshFlow listicle UGC).
      video.preload = "none";
      video.controls = false;
      video.playsInline = true;

      playButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        video.play().catch(() => {});
      });

      video.addEventListener("click", () => {
        if (video.paused) video.play().catch(() => {});
        else video.pause();
      });

      video.addEventListener("play", () => card.classList.add("is-playing"));
      video.addEventListener("pause", () => card.classList.remove("is-playing"));
      video.addEventListener("ended", () => card.classList.remove("is-playing"));
    });
  }
}

function initElVideoSlider(section = document) {
  new ElVideoSlider(section);
}

document.addEventListener("DOMContentLoaded", () => initElVideoSlider());
document.addEventListener("shopify:section:load", (event) => initElVideoSlider(event.target));
